import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import HotelList from 'components/HotelList';

import { makeAfter, withData } from 'lib';
import { HotelListPageQuery } from '__generated__/HotelListPageQuery.graphql';

const query = graphql`
  query HotelListPageQuery($first: Int!, $after: String, $search: String) {
    ...HotelList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<HotelListPageQuery>;
};

const HotelListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<HotelListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={[{ name: 'Viešbučiai' }]}>
      <Pagination>
        <Search>
          <HotelList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<HotelListPageQuery>({
  query,
  reloadOnRender: false,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(HotelListPage);
